import React from 'react';
import cx from 'classnames';
import { Switch, Route } from 'react-router';
import { useModuleRoute } from 'spindl-shared-components';

import PathSelector from '../../blocks/PathSelector';

import styles from './WizardPage.module.scss';
import usePresenter from './WizardPage.presenter';
import getProps from './WizardPage.props';
import { WizardPageCombinedProps } from './types';
import InviteUsers from '../../blocks/InviteUsers';
import UploadCSV from '../../blocks/UploadCSV';
import DownloadCSV from '../../blocks/DownloadCSV';

const WizardPage: React.FC<WizardPageCombinedProps> = (props) => {
  const {
    className,
    classes,
    pathSelector,
    isCSVTemplateDownloaded,
    setIsCSVTemplateDownloaded,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.wizardPage;
  const { modulePath } = useModuleRoute();
 
  return (
    <div className={cx(currentStyle, className)}>
      <Switch>
        <Route path={`${modulePath}/wizard/inviteUsers`}>
          <InviteUsers />
        </Route>
        <Route path={`${modulePath}/wizard/uploadCSV`}>
          <UploadCSV />
        </Route>
        <Route path={`${modulePath}/wizard/downloadCSV`}>
          <DownloadCSV
            isCSVTemplateDownloaded={isCSVTemplateDownloaded}
            setIsCSVTemplateDownloaded={setIsCSVTemplateDownloaded}
          />
        </Route>
        <Route path={''}>
          <PathSelector
            className={cx(styles.pathSelector, classes?.pathSelector)}
            {...internalProps.pathSelector}
            {...pathSelector}/>
        </Route>
      </Switch>

    </div>
  );
};

export default WizardPage;
